import { UtilityService } from '@eforall/common';
import { DialogService, GridSetup } from '@eforall/dashboard';
import { ContactEngagement } from '@interfaces';
import { AppService } from '../../../../../../services';
import { AccApplicationDialogDataService } from '../../../../acc-application-dialog/acc-application-dialog-data.service';
import { PersonDialogDataService } from '../../../person-dialog-data.service';
import { getActions } from './get-actions';
import { getButtons } from './get-buttons';
import { getColumns } from './get-columns';


export function getSetup(personDialogDataService: PersonDialogDataService, accApplDialogDataService: AccApplicationDialogDataService, util: UtilityService, dialog: DialogService, app: AppService): GridSetup<ContactEngagement> {

	return {
		rowName: { singular: 'Engagement', plural: 'Engagements' },
		getRowKey: row => '' + row.id,
		stateKey: 'person-engagements-grid',
		actions: getActions(personDialogDataService, dialog),
		buttons: getButtons(personDialogDataService, accApplDialogDataService, dialog),
		columns: getColumns(util, app),
	}
}
